import { useRouter } from 'next/router';

import { useOpenWindow } from '@/hooks';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';

export const getUserProfileHref = (userHashId: string) =>
  `/profile/${userHashId}`;

/**
 * 작성자 프로필을 새 탭으로 여는지. 기본은 같은 탭이고, 외부 플랫폼에선 프로필이 바로 되돌아가므로 새 탭으로 연다.
 * 앵커(`<Link target>`)는 이 값을, 클릭 핸들러는 `useOpenUserProfile` 을 쓴다.
 */
export const useOpensUserProfileInNewTab = () => useIsInExternalPlatform();

type OpenUserProfileOptions = {
  /** 화면 규칙과 상관없이 새 탭으로 연다 — 플레이 화면처럼 떠나면 안 되는 호출부가 넘긴다. */
  newTab?: boolean;
};

/** 작성자 프로필로 간다. 탭 규칙은 `useOpensUserProfileInNewTab` 를 따른다. */
export const useOpenUserProfile = () => {
  const router = useRouter();
  const openWindow = useOpenWindow();
  const opensInNewTab = useOpensUserProfileInNewTab();

  return (
    userHashId: string,
    { newTab = false }: OpenUserProfileOptions = {},
  ) => {
    const href = getUserProfileHref(userHashId);
    if (newTab || opensInNewTab) {
      openWindow(href);
      return;
    }
    void router.push(href);
  };
};
